import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// import Breadcrumbs from 'react-router-breadcrumbs'
// import { routes } from './../../App'

export const CustomBreadcrumbs = ({ breadcrumbs }) => {
  if (!breadcrumbs || !breadcrumbs.length) { breadcrumbs = [] }
  return (
    <ol className="breadcrumb">
      <li key="bc-Home" className="breadcrumb-item"><Link to="/">indexAR</Link></li>

      {breadcrumbs.map((b, index) => {
        if (typeof b === 'string') { return <li key={`bc-${index}`} className="breadcrumb-item active">{b}</li> }
        const { link, title } = b
        return <li key={`bc-${index}`} className="breadcrumb-item"><Link to={link}>{title}</Link></li>
      })}
    </ol>
  )
}

CustomBreadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
}

const Subheader = ({ breadcrumbs, searchValue, search, onSearch }) => (
  <div className="mai-sub-header d-flex align-items-center">
    <Container className="d-flex align-items-center justify-content-between">
      {/* <Breadcrumbs routes={routes} /> */}
      {/* hidden until implementation */}
      <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
      {search ? (
        <div className="search">
          <input type="text" placeholder="Search..." value={searchValue || ''} onChange={(e) => { onSearch(e.target.value) }} />
          <span className="s7-search" />
        </div>
      ) : null}
    </Container>
  </div>
);

Subheader.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  searchValue: PropTypes.string,
  search: PropTypes.bool,
  onSearch: PropTypes.func,
}

Subheader.defaultProps = {
  searchValue: '',
  search: false,
  onSearch: undefined
}

export default Subheader;



// WEBPACK FOOTER //
// ./src/components/Subheader/index.js